import { render } from "./DefaultTagSectionResultCmp.vue?vue&type=template&id=794de984"
import script from "./DefaultTagSectionResultCmp.vue?vue&type=script&lang=js"
export * from "./DefaultTagSectionResultCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__